module.exports = __webpack_public_path__ + "static/pudra-e50977b477421cd58e706adaf75626e8.svg";